import { forwardRef } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const SvgSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M37.323 3a19.632 19.632 0 0 0-15.531 31.684L3.011 53.464 6.547 57 25.33 38.217A19.655 19.655 0 1 0 37.323 3m0 34.332a14.666 14.666 0 1 1 14.666-14.666 14.68 14.68 0 0 1-14.666 14.666",
      fill: "currentColor"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
var ForwardRef$1 = ForwardRef;

export { ForwardRef$1 as default };
